<template>
  <div class="guest-information-statistics">
    <h2 class="h1">Guest information</h2>
    <div class="PieOuterWrapper">
      <div class="PieWrapper">
        <pie-chart
          class="PieChart"
          :chart-data="chartData"
          :options="chartOptions"
          :height="230"
        ></pie-chart>
      </div>
    </div>
    <h3 class="h6 reachableTitle">{{ guestReachableTitle }}</h3>
  </div>
</template>

<script>
import PieChart from "../../PieChart";
import countTotalMixin from "@/mixins/countTotalMixin";

export default {
  components: {
    PieChart,
  },
  mixins: [countTotalMixin],
  props: {
    statistics: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      chartData: {},
      chartOptions: {},
    };
  },
  watch: {
    statistics() {
      this.fillDataChart();
    },
  },
  mounted() {
    this.fillDataChart();
  },
  computed: {
    totalGuests() {
      return this.countTotal(this.statistics, "totalGuests");
    },
    guestsWithoutInfo() {
      return this.countTotal(this.statistics, "guestsWithoutInfo");
    },
    guestsWithPhoneNr() {
      return this.countTotal(this.statistics, "guestsWithPhoneNr");
    },
    guestsWithEmail() {
      return this.countTotal(this.statistics, "guestsWithEmail");
    },
    guestsWithPhoneAndEmail() {
      return this.countTotal(this.statistics, "guestsWithPhoneAndEmail");
    },
    guestsTotalReachable() {
      return (
        this.guestsWithPhoneAndEmail +
        this.guestsWithEmail +
        this.guestsWithPhoneNr
      );
    },
    guestReachableTitle() {
      return `REACHED: ${this.guestsTotalReachable} (${this.calcPercentage(
        this.guestsTotalReachable
      )}%)`;
    },
  },
  methods: {
    fillDataChart() {
      (this.chartOptions = {
        legend: {
          position: "right",
          labels: {
            boxWidth: 30,
            fontSize: 16,
            // fontStyle: 'bold',
            fontColor: "#5A5A5A",
            fontFamily: "Poppins",
            padding: 30,
          },
        },
        tooltips: {
          displayColors: false,
          xPadding: 25,
          yPadding: 8,
          titleFontSize: 16,
          bodyFontSize: 20,
          bodyAlign: "center",
          titleAlign: "center",
          backgroundColor: "#48b9ba",
        },
        cutoutPercentage: 80,
        elements: {
          center: {
            color: "#5A5A5A",
            fontStyle: "Poppins",
            sidePadding: 10,
          },
        },
      }),
        (this.chartData = {
          labels: [
            `ONLY PHONE (${this.calcPercentage(this.guestsWithPhoneNr)}%)`,
            `ONLY E-MAIL (${this.calcPercentage(this.guestsWithEmail)}%)`,
            `BOTH (${this.calcPercentage(this.guestsWithPhoneAndEmail)}%)`,
            `NO INFO (${this.calcPercentage(this.guestsWithoutInfo)}%)`,
          ],
          datasets: [
            {
              data: [
                this.guestsWithPhoneNr,
                this.guestsWithEmail,
                this.guestsWithPhoneAndEmail,
                this.guestsWithoutInfo,
              ],
              backgroundColor: ["#BD2C9D", "#2660A4", "#63A375", "#FF6B6C"],
            },
          ],
          responsive: true,
          maintainAspectRatio: false,
        });
    },
    calcPercentage(num) {
      if (this.totalGuests === 0) {
        return 0;
      }

      const n = (num / this.totalGuests) * 100;
      return n.toFixed(1);
    },
  },
};
</script>

<style scoped>
.reachableTitle {
  text-align: right;
}

.iamred {
  color: red;
}
</style>
